export const productInitialData = {
    answer: false,
    type: "",
    pcl_id: "",
    place: "",
    damaged_equipment: "",
    supply_equipment: "",
    date_install: "",
    date_warranty: "",
    modality: "",
    date_until: "",
}